import { API } from "shared/services";

export async function deleteProducts(customer, product) {
  await API.delete(`customers/${customer?.id}/products/${product?.id}`);
}

export function AddNewProduct(
  name,
  reference_code,
  price,
  url,
  channel,
  lead_source,
  custumer
) {
  return API.post(`customers/${custumer?.id}/products`, {
    product: {
      name: name,
      reference_code: reference_code,
      price: price,
      url: url,
      channel_id: channel?.id,
      lead_source_id: lead_source?.id,
    },
  });
}
